import {
  FETCH_ROUTINES_REQUEST,
  FETCH_ROUTINES_SUCCESS,
  FETCH_ROUTINES_FAILURE,
  FETCH_ROUTINE_DETAIL_REQUEST,
  FETCH_ROUTINE_DETAIL_SUCCESS,
  FETCH_ROUTINE_DETAIL_FAILURE,
  FETCH_SKIN_TYPES_REQUEST,
  FETCH_SKIN_TYPES_SUCCESS,
  FETCH_SKIN_TYPES_FAILURE,
  FETCH_POPULAR_ROUTINES_REQUEST,
  FETCH_POPULAR_ROUTINES_SUCCESS,
  FETCH_POPULAR_ROUTINES_FAILURE,
  INCREMENT_ROUTINE_USAGE_SUCCESS,
} from "../actions/routineActions";

const initialState = {
  routines: [],
  currentRoutine: null,
  skinTypes: [],
  popularRoutines: [],
  loading: false,
  detailLoading: false,
  skinTypesLoading: false,
  popularLoading: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  totalPages: 1,
};

const routineReducer = (state = initialState, action) => {
  switch (action.type) {
    // Routines list
    case FETCH_ROUTINES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ROUTINES_SUCCESS:
      return {
        ...state,
        loading: false,
        routines: action.payload.results || [],
        totalCount: action.payload.count || 0,
        currentPage: action.payload.page || 1,
        totalPages: Math.ceil((action.payload.count || 0) / (action.payload.per_page || 12)),
      };
    case FETCH_ROUTINES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Single routine detail
    case FETCH_ROUTINE_DETAIL_REQUEST:
      return {
        ...state,
        detailLoading: true,
        error: null,
      };
    case FETCH_ROUTINE_DETAIL_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        currentRoutine: action.payload,
      };
    case FETCH_ROUTINE_DETAIL_FAILURE:
      return {
        ...state,
        detailLoading: false,
        error: action.payload,
      };

    // Skin types
    case FETCH_SKIN_TYPES_REQUEST:
      return {
        ...state,
        skinTypesLoading: true,
      };
    case FETCH_SKIN_TYPES_SUCCESS:
      return {
        ...state,
        skinTypesLoading: false,
        skinTypes: action.payload,
      };
    case FETCH_SKIN_TYPES_FAILURE:
      return {
        ...state,
        skinTypesLoading: false,
        error: action.payload,
      };

    // Popular routines
    case FETCH_POPULAR_ROUTINES_REQUEST:
      return {
        ...state,
        popularLoading: true,
      };
    case FETCH_POPULAR_ROUTINES_SUCCESS:
      return {
        ...state,
        popularLoading: false,
        popularRoutines: action.payload,
      };
    case FETCH_POPULAR_ROUTINES_FAILURE:
      return {
        ...state,
        popularLoading: false,
        error: action.payload,
      };

    // Increment usage
    case INCREMENT_ROUTINE_USAGE_SUCCESS:
      return {
        ...state,
        currentRoutine: state.currentRoutine
          ? {
              ...state.currentRoutine,
              usage_count: (state.currentRoutine.usage_count || 0) + 1,
            }
          : null,
      };

    default:
      return state;
  }
};

export default routineReducer;

